import { Component, input, InputSignal } from '@angular/core';

/** Recurring brand glyphs rendered as inline SVG so they inherit `currentColor`. */
export type BrandIconName = 'asterisk' | 'block';

@Component({
    selector: 'app-brand-icon',
    templateUrl: './brand-icon.html',
    styleUrl: './brand-icon.scss',
})
export class BrandIcon {
    readonly name: InputSignal<BrandIconName> = input<BrandIconName>('asterisk');
}
